<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="middle-panel" style="height: unset" @click.stop v-if="!showSelectTargetGroup">
                <div class="dialog-title">
                    {{bellInfo == null ? $t('message.title_bell_create') : $t('message.title_bell_edit')}}
                </div>
                <hr class="dialog-hr" />

                <div class="dialog-body">
                    <el-form label-width="170px" class="dialog-form-item">
                        <!--- ベルID --->
                        <el-form-item prop="bellName" ref="bellName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_bell_edit_label1'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_name')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="bellName" size="large" type="text"
                                :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.bellName.value"
                                clearable :maxlength="MAX_NAME_LENGTH" show-word-limit
                                @compositionstart.native="compositionStart($event.target.id)"
                                @compositionend.native="compositionEnd($event.target.id)"
                                @input.native="inputCheck($event.target.id)" @clear="inputCheck($event.target.id)" />
                        </el-form-item>
                        <!--- ベル表示名 --->
                        <el-form-item prop="bellDisplayName" ref="bellDisplayName">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_bell_edit_label9'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_display_name')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-input id="bellDisplayName" size="large" type="text"
                                      :placeholder="$t('message.place_holder_input_text')" v-model="inputForm.bellDisplayName.value"
                                      clearable :maxlength="MAX_DISPLAY_NAME_LENGTH" show-word-limit
                                      @compositionstart.native="compositionStart($event.target.id)"
                                      @compositionend.native="compositionEnd($event.target.id)"
                                      @input.native="inputCheck($event.target.id)" @clear="inputCheck($event.target.id)" />
                        </el-form-item>
                        <!--- 通知先グループ --->
                        <el-form-item prop="targetGroups" ref="targetGroups">
                            <div slot="label" style="text-align:left;">
                                <span v-t="'message.item_bell_edit_label2'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_group')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-button style="padding: 10px 20px" @click="openSelectTargetGroup">
                                <span v-t="'message.action_selection'"></span>
                            </el-button>
                            <span class='selected-target-group'>{{ displayEditingTargetGroups }}</span>
                        </el-form-item>
                        <!-- 通知言語 -->
                        <el-form-item prop="notifyLang" ref="notifyLang">
                            <div slot="label" style="text-align:left">
                                <span v-t="'message.item_bell_edit_label4'"></span>
                                <span class="required" v-t="'message.item_required'"></span>
                                <el-tooltip effect="dark" placement="top-start">
                                    <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_lang')"></div>
                                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                </el-tooltip>
                            </div>
                            <el-select v-model="inputForm.notifyLang.value" @change="inputCheck('notifyLang')">
                                <el-option v-for="language in languageList" :key="language.value"
                                           :label="languageDescription(language)" :value="language.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div v-if="bellInfo !== null">
                            <!-- 通知する項目 -->
                            <el-form-item prop="notifyItems" ref="notifyItems">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_bell_edit_label10'"></span>
                                    <span class="required" v-t="'message.item_required'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.hint_bell_notify_items')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-checkbox-group id="notifyItems" v-model="inputForm.notifyItems.value" @change="inputCheck(`notifyItems`)">
                                    <el-checkbox v-for="item in notificationItems" :key="item.name" :label="item.name" :value="item.name">
                                        {{ notificationItemDescription(item) }}
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                            <!--- 利用時間 --->
                            <el-form-item prop="usageTime" ref="usageTime">
                                <div slot="label" style="text-align:left;">
                                    <span v-t="'message.item_bell_edit_label7'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.info_bell_usage_time_hint')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-radio-group class="ml-4" v-model="inputForm.usageTime.value.use" @change="inputCheck(`usageTime`)">
                                    <el-radio :label="true"> {{ $t('message.item_set') }} </el-radio>
                                    <el-radio :label="false"> {{ $t('message.item_not_set') }} </el-radio>
                                </el-radio-group>
                                <div class="time-select-wrapper">
                                    <el-time-select
                                        id="usageTimeStart" v-model="inputForm.usageTime.value.range.start"
                                        :disabled="!inputForm.usageTime.value.use"
                                        placeholder=""
                                        :clearable="false"
                                        :picker-options="{ start: '00:00', step: '00:10', end: '24:00' }"
                                        @blur="autoFillUsageTimeIfBlank">
                                    </el-time-select>
                                    <span> - </span>
                                    <el-time-select
                                        id="usageTimeEnd" v-model="inputForm.usageTime.value.range.end"
                                        :disabled="!inputForm.usageTime.value.use"
                                        placeholder=""
                                        :clearable="false"
                                        :picker-options="{ start: '00:00', step: '00:10', end: '24:00' }"
                                        @blur="autoFillUsageTimeIfBlank">
                                    </el-time-select>
                                </div>
                            </el-form-item>
                            <!--- 利用地点 --->
                            <el-form-item prop="usagePoint" ref="usagePoint">
                                <div slot="label" style="text-align:left">
                                    <span v-t="'message.item_bell_edit_label8'"></span>
                                    <el-tooltip effect="dark" placement="top-start">
                                        <div slot="content" style="text-align:left" v-html="$t('message.info_bell_usage_point_hint')"></div>
                                        <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                    </el-tooltip>
                                </div>
                                <el-radio-group class="ml-4" v-model="inputForm.usagePoint.value.use" @change="inputCheck(`usagePoint`)">
                                    <el-radio :label="true"> {{ $t('message.item_set') }} </el-radio>
                                    <el-radio :label="false"> {{ $t('message.item_not_set') }} </el-radio>
                                </el-radio-group>
                                <el-input type="text" v-model="inputForm.usagePoint.value.latlng"
                                          maxlength="100" style="width:460px" :disabled="!inputForm.usagePoint.value.use"
                                          :placeholder="$t('message.place_holder_input_latitude')"
                                          @input.native="inputCheck(`usagePoint`)"/>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <hr class="dialog-hr" />
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')"
                        v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" :disabled="disableButton" @click="saveChange()"
                        v-t="'message.button_save'"></el-button>
                </div>
            </div>

            <SelectTargetGroup v-if="showSelectTargetGroup" :tenantId="appData.tenantList[0].tenantId" :editingGroups="inputForm.targetGroups.value" @none="cancelSelectTargetGroup" @ok="setSelectTargetGroup"></SelectTargetGroup>
        </div>
    </transition>
</template>

<script>
import constants from "./constants";
import commonUtil from './commonutil.js';
import commonValidate from './common-validate.js';
import SelectTargetGroup from './BellSelectTargetGroup.vue';

export default {
    components: {
        SelectTargetGroup,
    },

    props: {
        bellInfo: Object,
        appData: Object,
    },

    data() {
        return {
            DEFAULT_LANGUAGE_CODE: null,
            DEFAULT_SECONDARY_LANGUAGE_CODE: null,

            MAX_NAME_LENGTH: constants.BELL_MAX_NAME_LENGTH,
            MAX_DISPLAY_NAME_LENGTH: constants.BELL_MAX_DISPLAY_NAME_LENGTH,

            // Fields
            inputForm: {
                bellName: {
                    validationRule: "bellName",
                    valid: false,
                    value: null,
                    isComposing: false,
                },
                bellDisplayName: {
                    validationRule: "bellDisplayName",
                    valid: false,
                    value: null,
                    isComposing: false,
                },
                targetGroups: {
                    validationRule: "requireArray",
                    valid: false,
                    value: [],
                    isComposing: false,
                },
                notifyLang: {
                    validationRule: "require",
                    valid: true, // set initial value according to locale
                    value: 0,
                    isComposing: false,
                },
                notifyItems: {
                    validationRule: "requireArray",
                    valid: true, // set default value
                    value: [],
                    isComposing: false,
                },
                usageTime: {
                    validationRule: "usageTime",
                    valid: true,
                    value: { use: false, range: { start: '', end: '' } },
                    isComposing: false,
                },
                usagePoint: {
                    validationRule: "usagePoint",
                    valid: true,
                    value: { use: false, latlng: "" },
                    isComposing: false,
                },
            },

            showSelectTargetGroup: false,
            // controllers
            languageList: [],
            notificationItems: [],
            disableButton: false,
        };
    },

    computed: {
        displayEditingTargetGroups() {
            return this.inputForm.targetGroups.value.map(g => g.talkgroupName).join(" / ");
        }
    },

    created() {
        this.DEFAULT_LANGUAGE_CODE = this.$i18n.locale === 'ja' ? 'ja-JP' : 'en-US';
        this.DEFAULT_SECONDARY_LANGUAGE_CODE = this.$i18n.locale === 'ja' ? 'en-US' : 'ja-JP';
        this.languageList = commonUtil.getLanguageIndexList();
        this.notificationItems = commonUtil.getBellNotificationItems();
        this.setupData();
        this.setButtonStatus();
    },

    methods: {
        languageDescription(language) {
            if (this.$i18n.locale === 'ja') {
                return language.description;
            } else {
                return language.description_en
            }
        },
        notificationItemDescription(item) {
            if (this.$i18n.locale === 'ja') {
                return item.description;
            } else {
                return item.description_en
            }
        },
        saveChange() {
            // input check
            this.inputCheckAll();
            if (!this.isCheckAllOk()) return;

            if (this.bellInfo == null) {
                let payload = {
                    name: this.inputForm.bellName.value,
                    displayName: this.inputForm.bellDisplayName.value,
                    groups: this.inputForm.targetGroups.value.map(g => g.talkgroupId),
                    notifyLang: this.inputForm.notifyLang.value,
                };

                this.$emit("create", payload);

            } else {
                let usageTime;
                if (this.inputForm.usageTime.value.use) {
                    let offset = -(new Date().getTimezoneOffset()); // e.g. +9:00 -> getTimezoneOffset returns -540.
                    usageTime = {
                        start: this.calculateMinutes(this.inputForm.usageTime.value.range.start, -offset),
                        end: this.calculateMinutes(this.inputForm.usageTime.value.range.end, -offset)
                    }
                } else {
                    usageTime = {start: null, end: null}
                }

                let usagePoint;
                if (this.inputForm.usagePoint.value.use) {
                    let parts = this.inputForm.usagePoint.value.latlng.split(',');
                    usagePoint = {latitude: parseFloat(parts[0].trim()), longitude: parseFloat(parts[1].trim())}
                } else {
                    usagePoint = {latitude: null, longitude: null}
                }

                let payload = {
                    id: this.bellInfo.id,
                    name: this.inputForm.bellName.value,
                    displayName: this.inputForm.bellDisplayName.value,
                    groups: this.inputForm.targetGroups.value.map(g => g.talkgroupId),
                    notifyLang: this.inputForm.notifyLang.value,
                    notifyItems: this.inputForm.notifyItems.value,
                    usageTime: usageTime,
                    usagePoint: usagePoint,
                };

                this.$emit("update", payload);
            }
        },
        openSelectTargetGroup() {
            this.showSelectTargetGroup = true;
        },
        cancelSelectTargetGroup() {
            this.showSelectTargetGroup = false;
        },
        setSelectTargetGroup(tagList) {
            this.showSelectTargetGroup = false;
            let latestEditingGroups = [];
            for (let key in tagList) {
                let tag = tagList[key];
                latestEditingGroups.push({
                    talkgroupTenantId: tag.tenantId,
                    talkgroupId: tag.talkgroupId,
                    displayName: tag.displayName,
                    optionFlag: tag.optionFlag,
                    talkgroupName: tag.talkgroupName,
                })
            }
            this.inputForm.targetGroups.value = latestEditingGroups;
            this.inputForm.targetGroups.valid = latestEditingGroups.length !== 0;
            this.setButtonStatus();
        },
        // Component-related
        setupData() {
            if (this.bellInfo === null) {
                // Add
                this.inputForm.notifyLang.value = this.$i18n.locale === 'ja' ? 1 : 2;
                this.inputForm.notifyLang.valid = true;
                this.inputForm.notifyItems.value = ['DISPLAY_NAME', 'TITLES', 'SELECTIONS']; // not use, but make inputForm valid
                this.inputForm.notifyItems.valid = true;
            } else {
                // Edit
                const {name, displayName, notifyLang, notifyItems, groups, usageTime, usagePoint} = this.bellInfo;

                this.inputForm.bellName.value = name;
                this.inputForm.bellName.valid = true;
                this.inputForm.bellDisplayName.value = displayName;
                this.inputForm.bellDisplayName.valid = true;
                this.inputForm.notifyLang.value = notifyLang;
                this.inputForm.notifyLang.valid = true;
                this.inputForm.notifyItems.value = notifyItems
                this.inputForm.notifyItems.valid = true;
                this.inputForm.targetGroups.value = groups;
                this.inputForm.targetGroups.valid = true;
                // usage point
                if (usagePoint.latitude && usagePoint.longitude) {
                    this.inputForm.usagePoint.value = {use: true, latlng: `${usagePoint.latitude}, ${usagePoint.longitude}`};
                } else {
                    this.inputForm.usagePoint.value = {use: false, latlng: ""};
                }
                this.inputForm.usagePoint.valid = true;
                // usage time
                if (usageTime.start && usageTime.end && usageTime.start !== usageTime.end) {
                    // Human-friendly notation
                    let offset = -(new Date().getTimezoneOffset());
                    this.inputForm.usageTime.value = { use: true, range: { start: this.calculateMinutes(usageTime.start, offset), end: this.calculateMinutes(usageTime.end, offset) } }
                    if (this.inputForm.usageTime.value.range.start === '24:00') {
                        this.inputForm.usageTime.value.range.start = '00:00';
                    }
                    if (this.inputForm.usageTime.value.range.end === '00:00') {
                        this.inputForm.usageTime.value.range.end = '24:00';
                    }
                } else {
                    this.inputForm.usageTime.value = { use: false, range: { start: "00:00", end: "24:00" } }
                }
                this.inputForm.usageTime.valid = true;
            }
        },
        calculateMinutes(time, minutes) {
            const parts = time.split(':');
            const date = new Date();
            date.setHours(parts[0]);
            date.setMinutes(parts[1]);

            date.setMinutes(date.getMinutes() + minutes);

            const hours = date.getHours().toString().padStart(2, '0');
            const mins = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${mins}`;
        },
        isCheckAllOk() {
            return commonValidate.checkFormValidation(this.inputForm);
        },
        setButtonStatus() {
            this.disableButton = !commonValidate.checkFormValidation(this.inputForm);
        },
        inputCheck(eventTargetId) {
            if (this.inputForm[eventTargetId].isComposing) {
                // inputting with IME
                return;
            }
            const validateResult = commonValidate.validateItem(this.$i18n, this.inputForm[eventTargetId].validationRule, this.inputForm[eventTargetId].value);
            if (validateResult.valid) {
                this.inputForm[eventTargetId].valid = true;
                if (this.$refs[eventTargetId]) {
                    this.$refs[eventTargetId].clearValidate();
                }
            } else {
                this.inputForm[eventTargetId].valid = false;
                if (this.$refs[eventTargetId]) {
                    this.$refs[eventTargetId].validateState = "error";
                    this.$refs[eventTargetId].validateMessage = validateResult.message;
                }
            }
            this.setButtonStatus();
        },
        inputCheckAll() {
            for (let targetId in this.inputForm) {
                this.inputCheck(targetId);
            }
        },
        compositionStart(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = true;
        },
        compositionEnd(eventTargetId) {
            this.inputForm[eventTargetId].isComposing = false;
            this.inputCheck(eventTargetId)
        },
        autoFillUsageTimeIfBlank() {
            // Human-friendly notation
            if (!this.inputForm.usageTime.value.range.start || this.inputForm.usageTime.value.range.start === "24:00") {
                this.inputForm.usageTime.value.range.start = "00:00";
            }
            if (!this.inputForm.usageTime.value.range.end || this.inputForm.usageTime.value.range.end === "00:00") {
                this.inputForm.usageTime.value.range.end = "24:00";
            }
            this.inputCheck("usageTime");
        }
    }
};
</script>

<style scoped>
.dialog-body {
    max-height: calc(80vh - 170px);
    padding: 20px 30px;
    font-size: 14px;
    overflow: auto;
}
.middle-panel {
    background: #fff;
    position: absolute;
    padding: 0;
    left: 50%;
    top: 50%;
    width: 690px;
    max-height: 80vh;
    margin-top: -40vh;
    margin-left: -345px;
    transition: all .3s ease;
    border-radius: 4px;
    -webkit-border-radius: 4px;
    -moz-border-radius: 4px;
}
.selected-target-group {
    padding-left: 10px;
}
.time-select-wrapper {
    display: flex; /* Makes the wrapper a flex container */
    align-items: center; /* Vertically aligns items in the center */
    margin-top: 10px; /* Optional: Adds some space between the radio group and time select */
}
.time-select-wrapper > * {
    margin-right: 5px; /* Optional: Adds some space between the time select elements */
}
</style>
